import { VExpansionPanels } from 'vuetify/lib/components/VExpansionPanel';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(VExpansionPanels,{attrs:{"accordion":"","max":_vm.maxSelections,"multiple":_vm.shouldAllowMultipleSelections},model:{value:(_setup.openPanels),callback:function ($$v) {_setup.openPanels=$$v},expression:"openPanels"}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }